function bufferToHex(buffer) {
	return Array.from(new Uint8Array(buffer))
		.map((byte) => byte.toString(16).padStart(2, '0'))
		.join('')
}

export async function getSha256(file) {
	try {
		if (!window.crypto?.subtle || !file?.arrayBuffer) {
			return null
		}
		const buffer = await file.arrayBuffer()
		const hashBuffer = await window.crypto.subtle.digest('SHA-256', buffer)
		return bufferToHex(hashBuffer)
	} catch (error) {
		return null
	}
}
